import { ColDef, ColGroupDef, GridApi, IRowNode } from "ag-grid-enterprise";
import { ProductPbsManufacturer } from "models/dbModels/products/ProductPbsManufacturer";
import { Button } from "react-bootstrap";



export function getPreferredBrandsManufacturerConfig(totalRows: number, updateRedux: ()=> void): (ColDef<ProductPbsManufacturer> | ColGroupDef<ProductPbsManufacturer>)[]| null {
    return [
        {
            field: "pbsManufacturerId",
            hide: true
        },
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Rank",
            width: 300,
            field: "rank",
            sort: "asc",        
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                        
                        children: 
                            <div className="d-flex">
                                <div className="ps-1 pe-3">{params.data?.rank}</div>
                                <div className="rank-actions">
                                    {params.data!.rank < totalRows ? (
                                        <Button variant="light" className="btn-icon me-1 table-action-btn" onClick={() => {moveManufacturer(params.api, params.data!.rank, true);   updateRedux();}}>
                                            <i className="uil-arrow-down"></i>
                                        </Button>
                                    ) : null
                                    }
                                    {params.data!.rank > 1 ? (
                                        <Button variant="light" className="btn-icon me-1 table-action-btn" onClick={() => {moveManufacturer(params.api, params.data!.rank, false);   updateRedux();}}>
                                            <i className="uil-arrow-up"></i>
                                        </Button>
                                    ) : null
                                    }
                                </div>
                            </div>
                        }
                }          
            }
        },
        {
            headerName: "Manufacturer",
            field: "name",
            width: 300,
           
        },
        {
            headerName: "Code",
            field: "code",
            flex: 1
        }
    ];
}

function moveManufacturer(api :GridApi<any>, rank: number, moveDown: boolean) {
    console.log(api.getRowNode("3"));
    let rowBeingModified: IRowNode<any> | undefined = undefined;
    let rowAfterBeingModified: IRowNode<any> | undefined = undefined;
    let rowBeingSwitchedName = "";
    let rowBeingSwitchedCode = "";
    let rowBeingSwitchedid = null;
    api.forEachNode(node => {
        if (node.data.rank == rank){
            rowBeingModified = node;               
        }
        if (node.data.rank == (rank+1) && moveDown == true){
            rowAfterBeingModified = node;
            rowBeingSwitchedName = node.data.name;
            rowBeingSwitchedCode = node.data.code;
            rowBeingSwitchedid = node.data.pbsManufacturerId;
        }
        if (node.data.rank == (rank-1) && moveDown == false){
            rowAfterBeingModified = node;
            rowBeingSwitchedName = node.data.name;
            rowBeingSwitchedCode = node.data.code;
            rowBeingSwitchedid = node.data.pbsManufacturerId;
        }
    });
    if(rowBeingModified != undefined && rowAfterBeingModified != undefined){
        (rowAfterBeingModified as IRowNode<any>).setDataValue("name", (rowBeingModified as IRowNode<any>).data.name); 
        (rowAfterBeingModified as IRowNode<any>).setDataValue("code", (rowBeingModified as IRowNode<any>).data.code); 
        (rowAfterBeingModified as IRowNode<any>).setDataValue("pbsManufacturerId", (rowBeingModified as IRowNode<any>).data.pbsManufacturerId); 
        (rowBeingModified as IRowNode<any>).setDataValue("name", rowBeingSwitchedName);
        (rowBeingModified as IRowNode<any>).setDataValue("code", rowBeingSwitchedCode);
        (rowBeingModified as IRowNode<any>).setDataValue("pbsManufacturerId", rowBeingSwitchedid);
    }
    
    if(api.isQuickFilterPresent() == true){
        const filter = api.getQuickFilter();
        api.setGridOption('quickFilterText', "");
        api.setGridOption('quickFilterText', filter);
    }      
}